module.exports = __webpack_public_path__ + "static/media/screenshot1_new.9f0fb7a5.png";